import { render, staticRenderFns } from "./FilterTag.vue?vue&type=template&id=0462d35c&scoped=true"
import script from "./filterTag.ts?vue&type=script&lang=ts&external"
export * from "./filterTag.ts?vue&type=script&lang=ts&external"
import style0 from "./FilterTag.vue?vue&type=style&index=0&id=0462d35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0462d35c",
  null
  
)

export default component.exports